var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.365 17.943a4.46 4.46 0 01-1.26.2 3.45 3.45 0 01-2.879-1.797l-1.718-2.367-4.155.021-2.543-1.893-.007.006A.49.49 0 007.5 12a.5.5 0 00-.5.5.487.487 0 00.084.26l-.007.007L9 15.404l-.003.002v8.604a1.002 1.002 0 002.004 0v-4.504h8v4.507a.999.999 0 001.998 0v-6.296zm1.867-8.281V7.577a5.344 5.344 0 00-2.474 2.056l-1.332 1.604-3.56-4.59a1.472 1.472 0 00-1.07-.648 1.131 1.131 0 00-.421.085l-1.407.648a.819.819 0 00-.507.733 1.434 1.434 0 00.252.844s5.422 7.583 5.47 7.648a2.328 2.328 0 001.844 1.18 7.24 7.24 0 002.173-.566c.493-.21.81-.477.81-1.01a1.509 1.509 0 00-.266-.808l-.158-.248c.191-.608.638-.94 1.139-.83a4.46 4.46 0 001.293.329c.87 0 1.366-.6 1.984-2.008zm-8.718-.649a.149.149 0 01-.112-.056l-.9-1.267a.105.105 0 01-.028-.085c0-.028 0-.056.058-.084l1.18-.536c.057-.028.057-.028.084-.028a.1.1 0 01.085.028l.958 1.212a.218.218 0 01.055.112c0 .057 0 .057-.055.085l-1.182.591a.263.263 0 01-.143.028zm2.988 4.252l-2.284-3.237a.245.245 0 01-.056-.17c0-.028.028-.056.055-.084l1.268-.62a.302.302 0 01.084-.027.336.336 0 01.17.14l2.096 2.674z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--guide-dog-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'GuideDogCircleIcon';
export default Icon;